import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "@denishussar/html5-game-engine";
import { Rectangle } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { SoundConstants, SoundLevels } from "../../Constants/SoundConstants";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";

export interface  IExitButtonControllerOptions {
    onClick: ()=>void;
};

export class UIExitButtonController extends AnimationBaseController{
    public $model: GameModel; 
    constructor(
        @Inject private options: IExitButtonControllerOptions,
        @Inject private gameLogic : GameLogic,
        
    )
    {
        super("UIExitButtonController");
    }

    public getConfiguration(): IAnimationControllerConfiguration {
        
        return {
            animationContent: AnimationContents.EXIT_BUTTON_JSON,
            libraryName: "btn_exit",
            sounds: [
                {
                    id:SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                }
            ],
            onPointerOver: ()=>{
                this.gotoAndStop("over");
            },
            onPointerOut: ()=>{
                this.gotoAndStop("up");
            },
            onPointerDown: ()=>{
                this.gotoAndStop("down");
                this.soundManager.playSound(SoundConstants.BUTTON_CLICK, 0, SoundLevels.UI_ACTION);
                this.options.onClick();
            },
            onPointerUp: ()=>{
                this.gotoAndStop("up");
            },
        }

    }

    public onResize(width: number, height: number, scale:number){
        console.log(this);
        this.scaleX = 1.3;
        this.scaleY = 1.3;
        this.x = width/scale/2.1-this.container.width;
        this.y = -height/scale/2+this.container.height;
        
    }

    public onInitialize() : void {
        this.gotoAndStop("over");
        this.container.hitArea = new Rectangle(-150/2, -150/2, 150, 150);
        this.gotoAndStop("up");
    }
}